import React, { Component } from "react";
import { Container, Row, Col, Button, Form, FormGroup, Label, Input, Modal, ModalBody, DropdownItem, DropdownMenu, UncontrolledDropdown, DropdownToggle } from 'reactstrap';
import httpClient from "../../httpClient";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDown, faAngleLeft, faAngleRight, faPlus, faTimes
} from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux';
import data from '../data/data.json'
import { addAnn, addCar, addVol, addHeberg, addPhotoHeberg, addVoyage, addVisa, addAgendaHeberg } from "../../slices/modalSlice";
import AddVolAnnounce from "../common/Vols/addVolAnnounce";
import AddImages from "./addImages";
import { MobileDateRangePicker, DateRangePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { Box } from '@mui/material';

import AddVoyageAnnounce from "../common/Voyages/addVoyage";
import { addTransfert } from "../../slices/modalSlice";


class AddAnnounceHbergement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      announceHbergInfo: { title: '', description: '', prix: 500, currency: "DZD", pays: "Algerie", region: "Chlef", commune: "Chlef", linkGPS: '', nbrRoom: 1, nbrAdulte: 1, nbrChildren: 1, equipement: [], dejeuné: "Inclus", annulation: "Remboursable", files: [], imagName: [], agenda: [] },
      isoOpenHeberg: false,
      isOpenAddanc: false,
      categorie: "Hébergement",
      heberg_sous_catego: ["Hotel", "Studio", "Appartement", "Chambre d'hotes", "Villa", "Auberge", "Bivouac", "Camping", "Bangalow", "Chambre"],
      cars_sous_catego: ["Location Voitures","Transfert de voyageurs"],
      vols_sous_catego: ["Vol charters"],
      voyages_sous_catego: ["Dans le Monde", "Hajj/Omra"],
      visa_sous_catego: ["visa"],
      sous_categories: ["Hotel", "Studio", "Appartement", "Chambre d'hotes", "Villa", "Auberge", "Bivouac", "Camping", "Bangalow", "Chambre"],
      sous_categorie: "Hotel",
      isoOpenCars: false,
      photoModalOpen: false,
      wilayaId: 15,
      imgUrl: [],
      alertMaxPic: false,
      date: [null, null],
      dates: []

    }
    this.toogleClose = this.toogleClose.bind(this);
    this.toogleCloseDetailsWindows = this.toogleCloseDetailsWindows.bind(this);
    this.toogleClosePhotos = this.toogleClosePhotos.bind(this);
    this.toogleCloseAgendaWindows = this.toogleCloseAgendaWindows.bind(this);
  };


  // onInputChange(evt) {
  //   if (evt.target.type !== "checkbox") {
  //     this.setState({
  //       announceHbergInfo: {
  //         ...this.state.announceHbergInfo,
  //         [evt.target.name]: evt.target.value
  //       }
  //     });
  //   }
  // }


  onInputChange(evt) {
    if (evt.target.type !== "checkbox") {
      this.setState({
        announceHbergInfo: {
          ...this.state.announceHbergInfo,
          [evt.target.name]: evt.target.value.toLowerCase()
        }
      })
    }
    else if (evt.target.type === "checkbox") {
      const value = evt.target.nextSibling.data.toLowerCase() ;
      const copie = this.state.announceHbergInfo.equipement;
      let index = copie.indexOf(value);
      if (index === -1) {
        this.setState({
          announceHbergInfo: {
            ...this.state.announceHbergInfo,
            equipement: [...this.state.announceHbergInfo.equipement, value.replaceAll(' ', "+")]
          }
        });
      } else {
        this.setState({ 
          announceHbergInfo: {
            ...this.state.announceHbergInfo,
            equipement: copie.filter((item) => item !== value),
          }
        });
      }
    }
  }


  onChangeUpload(e) {
    if (this.state.imgUrl.length <= 4) {
      this.setState({ files: e.target.files[0] });
      e.preventDefault();

      this.setState({
        announceHbergInfo: {
          ...this.state.announceHbergInfo,
          files: [...this.state.announceHbergInfo.files, e.target.files[0]]
        }
      })

      const fileReader = new FileReader();
      fileReader.onload = () => {
        this.setState({ imgUrl: [...this.state.imgUrl, fileReader.result] });
      }
      fileReader.readAsDataURL(e.target.files[0]);

    }

    else (
      this.setState({
        alertMaxPic: true
      })
    )
  }


  postAnnounceHeberg(evt) {
    evt.preventDefault()

    const idOwner = this.props.idOwner ;
    const typeAnnounce = "Hebergement" ;
    const files = this.state.announceHbergInfo.files ;
    const info = this.state.announceHbergInfo ;
    info.type = this.state.sous_categorie.toLowerCase() ;
    httpClient.createAnnounceHebergement(info, idOwner, typeAnnounce, files).then(sent => {
      this.setState({
        announceHbergInfo: {
          title: '', description: '', prix: 500, currency: "DZD", pays: "Algerie", region: "Chlef", commune: "Chlef", linkGPS: '', nbrRoom: 1, nbrAdulte: 1, nbrChildren: 1, equipement: [], dejeuné: "Inclus", annulation: "Remboursable", files: [], imagName: [], agenda: []
        },
        isoOpenHeberg: false
      })
      if (sent) {
        this.toogleCloseAgendaWindows();
      }
      if (sent === "Announce Creation failed") {
        this.toogleCloseAgendaWindows();
        this.props.dispatch(addHeberg())

      }
    })
  }

  FormatAgenda() {
    const obj = this.state.dates.map(([debut, fin]) => ({ debut, fin }));
    this.setState({
      announceHbergInfo: {
        ...this.state.announceHbergInfo,
        agenda: obj
      }
    });
  }



  toogleClose = () => this.props.dispatch(addAnn())
  toogleCloseDetailsWindows = () => this.props.dispatch(addHeberg())
  toogleClosePhotos = () => this.props.dispatch(addPhotoHeberg())
  toogleCloseAgendaWindows = () => this.props.dispatch(addAgendaHeberg())



  getDataFromDropDown_Categorie(e) {
    e.preventDefault()
    this.setState({ categorie: e.currentTarget.textContent });
    switch (e.currentTarget.textContent) {
      case "Hébergement":
        {
          this.setState({ sous_categories: this.state.heberg_sous_catego })
          this.setState({ sous_categorie: this.state.heberg_sous_catego[0] })
        }
        break;
      case "Voiture":
        {
          this.setState({ sous_categories: this.state.cars_sous_catego })
          this.setState({ sous_categorie: this.state.cars_sous_catego[0] })
        }
        break;
      case "Vols":
        this.setState({ sous_categories: this.state.vols_sous_catego })
        this.setState({ sous_categorie: this.state.vols_sous_catego[0] })
        break;
      case "Voyage organiser":
        this.setState({ sous_categories: this.state.voyages_sous_catego })
        this.setState({ sous_categorie: this.state.voyages_sous_catego[0] })
        break;
      case "Visa":
        this.setState({ sous_categories: this.state.visa_sous_catego })
        this.setState({ sous_categorie: this.state.visa_sous_catego[0] })
        break;
      default:
        break;
    }
  }

  getData_Sous_Categorie(e) {
    e.preventDefault()
    this.setState({ sous_categorie: e.currentTarget.textContent });
  }

  getData_dropDown(e, wilaya, id) {
    e.preventDefault()
    this.setState({
      announceHbergInfo: {
        ...this.state.announceHbergInfo,
        [e.currentTarget.name]: wilaya || e.currentTarget.textContent
      },
      wilayaId: id || this.state.wilayaId
    });
  }

  handleAddFields = (e) => {
    e.preventDefault()
    const values = [...this.state.dates];
    values.push([null, null])
    this.setState({
      dates: [...values]
    });
  };
  handleRemoveFields = (evt, i) => {
    evt.preventDefault()

    const values = [...this.state.dates];
    if (values.length > 1) values.splice(i, 1);
    this.setState({
      dates: [...values]
    });
  };

  render() {
    const alertMaxPic = this.state.alertMaxPic
    const wilayaNameItem = data.wilayas.map(function (item, i) {
      return (
        <DropdownItem name="region" onClick={e => this.getData_dropDown(e, item.name, i)}> <span>{i + 1}</span> {item.name}</DropdownItem>
      )
    }, this)


    const dairasNameItem = data.wilayas[this.state.wilayaId].dairas.map(function (item, i) {
      return (
        <DropdownItem name="commune" onClick={e => this.getData_dropDown(e, item.name, i)}> <span>{i + 1}</span> {item.name}</DropdownItem>
      )
    }, this)

    let sg = this.state.sous_categories.map((sous) => {
      return <DropdownItem onClick={e => { this.getData_Sous_Categorie.bind(this)(e) }}>{sous}</DropdownItem>
    })
    const { title, pays, region, commune, description, prix, linkGPS, nbrAdulte, nbrRoom, nbrChildren, dejeuné, currency, agenda } = this.state.announceHbergInfo
    const dates = this.state.dates
    // dates.push(this.state.date)

    const imag0 = this.state.imgUrl[0]
    const imag1 = this.state.imgUrl[1]
    const imag2 = this.state.imgUrl[2]
    const imag3 = this.state.imgUrl[3]
    const imag4 = this.state.imgUrl[4]
    return (

      <div style={{ marginTop: "75px" }}>
        <Modal isOpen={this.props.addAnn} toggle={this.toogleClose} className="modal-width-addAnnounce">

          <nav className="nav-windows-addanounce">
            <button className="close-heberg" onClick={this.toogleClose} >
              <span><FontAwesomeIcon icon={faTimes} /></span>
            </button>
            <div className="title-announce">Nouvelle Annonce</div>
          </nav>

          <ModalBody>
            <Container>
              <Form >
                <Row>
                  <Col sm="4" className="label-add_announce col-sm-4-modify"><label>Catégorie</label></Col>
                  <Col>
                    <FormGroup >
                      <UncontrolledDropdown nav   >
                        <DropdownToggle className="button-add-announce">
                          {this.state.categorie}
                          <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                        </DropdownToggle >
                        <DropdownMenu className="categorie-drop-down" >
                          <DropdownItem value={0} onClick={e => { this.getDataFromDropDown_Categorie.bind(this)(e) }}>Hébergement</DropdownItem>

                          <DropdownItem value={1} onClick={e => { this.getDataFromDropDown_Categorie.bind(this)(e) }} >Voiture</DropdownItem>

                          <DropdownItem value={2} onClick={e => { this.getDataFromDropDown_Categorie.bind(this)(e) }} >Vols</DropdownItem>

                          <DropdownItem value={3} onClick={e => { this.getDataFromDropDown_Categorie.bind(this)(e) }} >Visa</DropdownItem>

                          <DropdownItem value={4} onClick={e => { this.getDataFromDropDown_Categorie.bind(this)(e) }} >Voyage organiser</DropdownItem>




                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </FormGroup>
                  </Col>
                </Row>

                <br />

                <Row>
                  <Col sm="4" className="label-add_announce col-sm-4-modify">
                    <label>Sous-Catégorie</label>
                  </Col>
                  <Col>


                    <UncontrolledDropdown nav  >

                      <DropdownToggle id="test" className="button-add-announce">
                        {this.state.sous_categorie}
                        <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                      </DropdownToggle>

                      <DropdownMenu className="categorie-drop-down">
                        {sg}
                        {/* <DropdownItem value="Hébergement" onClick={e=>{this.getData_Sous_Categorie.bind(this)(e)}}>Appartement</DropdownItem>
                    <DropdownItem value="Hotels"  onClick={e=>{this.getData_Sous_Categorie.bind(this)(e)}}>Hotels</DropdownItem>
                    <DropdownItem value="Location Voiltures" onClick={e=>{this.getData_Sous_Categorie.bind(this)(e)}}>Location Voiltures</DropdownItem> */}
                      </DropdownMenu>
                    </UncontrolledDropdown>


                  </Col>
                </Row>



                <Row>
                  <div className="buttons-add-announce">
                    <Button className=" btn button-add-moule retour-button"><FontAwesomeIcon id="arrow-retour" icon={faAngleLeft} />Retour</Button>
                    <Button className=" btn button-add-moule suivant-button"
                      onClick={(evt => {
                        this.toogleClose();
                        if (this.state.categorie === "Hébergement")
                          this.props.dispatch(addHeberg());
                        else if (this.state.categorie === "Voiture") {
                          if(this.state.sous_categorie ==="Location Voitures"){
                            this.props.dispatch(addCar())
                          }else if (this.state.sous_categorie === "Transfert de voyageurs"){
                          this.props.dispatch(addTransfert())
                          }
                        }
                        else if (this.state.categorie === "Vols") {
                          this.props.dispatch(addVol())

                        } else if (this.state.categorie === "Voyage organiser") {
                          this.props.dispatch(addVoyage())
                        } else if (this.state.categorie === "Visa") {
                          this.props.dispatch(addVisa())
                        }

                      })}
                    >Suivant<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} /></Button>
                  </div>
                </Row>

              </Form>
            </Container>
          </ModalBody>
        </Modal>




        <AddVolAnnounce />





        {/* window details Announce Hebergement  */}

        <Modal isOpen={this.props.addHeberg} toggle={this.toogleCloseDetailsWindows} className="modal-width-details-announce">
          <nav className="nav-windows-addanounce">
            <button className="close-heberg" onClick={this.toogleCloseDetailsWindows} >
              <span><FontAwesomeIcon icon={faTimes} /></span>
            </button>
            <div className="title-announce" >
              Nouvelle Annonce - Hebergement
            </div>
          </nav>

          <div className="path-heberg">
            <div className="item-path-hebrg" style={{ backgroundColor: "#182952" ,borderRadius:"30px",marginLeft:"-15px" }}>

              <div className="number-path" style={{ backgroundColor: "white" }}>
                <span className="number-path-value" style={{ color: "#182952" }}>1</span>
              </div>

              <span className="name-path" style={{ color: "white" }}>
                Détails
                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

              </span>

            </div>

            <div className="item-path-hebrg" style={{marginLeft:"15px"}}>

              <div className="number-path" >
                <span className="number-path-value" >2</span>
              </div>

              <span className="name-path" >
                Photos
                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

              </span>

            </div>

            <div className="item-path-hebrg">

              <div className="number-path">
                <span className="number-path-value">3</span>
              </div>

              <span className="name-path last-path">
                Agenda

              </span>

            </div>



          </div>



          <ModalBody>
            <div className="line-after-path"></div>
            <Container>
              <div className="custom-container">
                <Form onChange={this.onInputChange.bind(this)} >

                  <Row className="second-Row">
                    <Col sm="1" id="label-title-input"><label>Titre</label></Col>
                    <Col sm="10" className="input-width"><Input type="text" name="title" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={title} required></Input></Col>
                  </Row>


                  <Row className="second-Row">
                    <Col sm="4" className="pr-0">
                      <Row>
                        <Col sm="3" id="label-title-input"><label>Pays</label></Col>
                        <Col>
                          <UncontrolledDropdown nav >
                            <DropdownToggle className="button-add-pays ">
                              {pays}
                              <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right className="full-width">
                              <DropdownItem name="pays" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Algerie</DropdownItem>
                              {/* <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Italia</DropdownItem>
                            <DropdownItem name="pays" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>France</DropdownItem> */}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>

                    <Col sm="4" className="pl-0">
                      <Row>
                        <Col sm="3" id="label-title-input"><label>Region</label></Col>
                        <Col>
                          <UncontrolledDropdown nav >
                            <DropdownToggle onClick={e => { this.getData_dropDown.bind(this)(e) }} className="button-add-announce">
                              {region}
                              <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }} >
                              {wilayaNameItem}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>

                    <Col sm="4" className="pl-0">
                      <Row>
                        <Col sm="4" id="label-title-input"><label>Commune</label></Col>
                        <Col>
                          <UncontrolledDropdown nav >
                            <DropdownToggle className="button-add-announce">
                              {commune}
                              <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px", overflowY: "scroll" }}>
                              {dairasNameItem}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>

                  </Row>

                  <Row className="second-Row">
                    <Col sm="2" className="pr-0" id="label-title-input"><label>Lien sur Google Map</label></Col>
                    <Col sm="9" className="input-width"><Input type="text" name="linkGPS" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={linkGPS}></Input></Col>
                  </Row>

                  <Row className="second-Row">
                    <Col sm="1" className="pr-0" id="label-title-input"><label>Description</label></Col>
                    <Col sm="10" className="input-width"><Input type="textarea" name="description" placeholder="Decriver votre annonce" className="text-area-descr" value={description} required></Input></Col>
                  </Row>

                  <Row className="second-Row">
                    <Col sm="4"><label>Nombre de chambre</label><input type="number" min="1" defaultValue="1" className="number-input-announce" name="nbrRoom" value={nbrRoom} /></Col>
                    <Col sm="4"><label>Nombre des Adultes</label><input type="number" min="1" defaultValue="2" className="number-input-announce" name="nbrChildren" value={nbrAdulte} /></Col>
                    <Col sm="4"><label>nbr des enfants</label><input type="number" min="1" defaultValue="1" className="number-input-announce" name="nbrRoom" value={nbrRoom} /></Col>
                  </Row>

                  <Row className="second-Row ">
                    <Col sm="4" className="row align-items-center"><label className="col-4">Prix</label><input type="number" min="1" defaultValue="1" className="price-input-announce col-7" name="prix" value={prix} required /></Col>
                    <Col sm="2">
                      <UncontrolledDropdown nav >
                        <DropdownToggle className="button-prix-announce">
                          {currency.toLocaleUpperCase()}
                          <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                        </DropdownToggle>
                        <DropdownMenu right className="full-width">
                          <DropdownItem name="currency" onClick={e => { this.getData_dropDown.bind(this)(e) }}>DZD</DropdownItem>
                          <DropdownItem name="currency" onClick={e => { this.getData_dropDown.bind(this)(e) }}>EUR</DropdownItem>
                          <DropdownItem name="currency" onClick={e => { this.getData_dropDown.bind(this)(e) }}>US</DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </Col>
                    <Col sm="6">
                      <Row className="align-items-center">
                        <Col sm="3"><label className="condition">Cond.annulation</label></Col>
                        <Col sm="9">
                          <UncontrolledDropdown nav >
                            <DropdownToggle className="button-add-announce" >
                              {this.state.announceHbergInfo.annulation}
                              <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu style={{ width: "70%" }}>
                              <DropdownItem name="annulation" onClick={e => { this.getData_dropDown.bind(this)(e) }}>remboursable</DropdownItem>
                              <DropdownItem name="annulation" onClick={e => { this.getData_dropDown.bind(this)(e) }}>remboursable</DropdownItem>
                              <DropdownItem name="annulation" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Demi-remboursable</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div className="line-after-path second-Row"></div>


                  <Row className="second-Row">
                    <Col sm="4">
                      <Row>
                        <Col sm="4" id="label-title-input"><label>Petit-dej</label></Col>
                        <Col>
                          <UncontrolledDropdown nav >
                            <DropdownToggle className="button-add-pays title-announce-input">
                              {dejeuné}
                              <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="dejeuné" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Inclus</DropdownItem>
                              <DropdownItem name="dejeuné" onClick={e => { this.getData_dropDown.bind(this)(e) }}>Non-Inclus</DropdownItem>
                              <DropdownItem name="dejeuné" onClick={e => { this.getData_dropDown.bind(this)(e) }}>juste Matin</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>

                    <Col sm="4">
                      <Row>
                        <Col sm="3" id="label-title-input"><label>Dejeuner</label></Col>
                        <Col>
                          <UncontrolledDropdown nav >
                            <DropdownToggle className="button-add-announce">
                              30000
                              <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem>Hébergement</DropdownItem>
                              <DropdownItem>Hotels</DropdownItem>
                              <DropdownItem>Location Voiltures</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>

                    <Col sm="4">
                      <Row>
                        <Col sm="4" id="label-title-input"><label>Dinner</label></Col>
                        <Col>
                          <UncontrolledDropdown nav >
                            <DropdownToggle className="button-add-announce">
                              +200000
                              <FontAwesomeIcon id="arrow-addAnnounce" icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem>Hébergement</DropdownItem>
                              <DropdownItem>Hotels</DropdownItem>
                              <DropdownItem>Location Voiltures</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                  <div className="line-after-path second-Row"></div>

                  <Row className="second-Row">
                    <Col sm="3" className="column-equipement">
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Sale de bein</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Climatisation</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Wi-Fi</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Ascenceur</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Portier</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Séche-ligne</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Séche-cheveux</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Jardin</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />WC Anglaise</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />SPA</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Départ tardif</Label></FormGroup>
                    </Col>

                    <Col sm="3" className="column-equipement">
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Cuisine</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Chauffage</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Lave-linge</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Lave-vaisselle</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Télévision</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Fer-Table a repasser</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Bureau</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Vue sur mer</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />isolement Acoustique</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Hammam</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Arrivé tardive</Label></FormGroup>
                    </Col>

                    <Col sm="3" className="column-equipe ment">
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Accés pers a mobilité réduite</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Climatisation</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Piscine</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Jacussi</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Eau chaude</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Ustensille de cuisine</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Parking gratuit</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Pas de vis-a-vis</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Chambre communicante</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Salle de Conférences</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Prises USb</Label></FormGroup>
                    </Col>

                    <Col sm="3" className="column-equipement">
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Tv tnt</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Mosquée a prox</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Literie sur place</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Réfrigérateur</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Micro-onde</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Cafétérie-Thélère</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Eau 24-24h</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Bus-Tram-Métro</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Salle de sports</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Court de Tennis</Label></FormGroup>
                      <FormGroup check><Label className="mb-3" check><Input type="checkbox" />Cintres</Label></FormGroup>
                    </Col>

                  </Row>


                  <Row className="second-Row">
                    <Col sm="1" id="label-title-input"><label>Autres</label></Col>
                    <Col sm="8"><Input type="text" name="username" placeholder="Equipement non-cités" className="title-announce-input" ></Input></Col>
                  </Row>
                  <div className="line-after-path second-Row"></div>

                  {/* <FormGroup check className="check-box form-check-equipement"><Label check><Input name="plus" type="checkbox" />Set the height and width for all checked elements:</Label></FormGroup>
                  <FormGroup check className="check-box form-check-equipement"><Label check><Input name="plus" type="checkbox" />Set the height and width for all checked elements:</Label></FormGroup> */}

                  <div className="buttons-details-announces">
                    <Button className=" btn button-add-moule retour-button"><FontAwesomeIcon id="arrow-retour" icon={faAngleLeft} />Retour</Button>
                    <Button className=" btn button-add-moule suivant-button"
                      // type="submit"
                      disabled={!this.state.announceHbergInfo.title || !this.state.announceHbergInfo.description}
                      onClick={(evt => {
                        this.toogleCloseDetailsWindows();
                        this.props.dispatch(addPhotoHeberg())
                      })}
                    >Suivant<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} />
                    </Button>
                    {/* onClick={this.postAnnounceHeberg.bind(this)} */}
                  </div>

                </Form>
              </div>
            </Container>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.props.addPhotoHeberg} toggle={this.toogleClosePhotos} className="modal-width-images-announce">
          <nav className="nav-windows-addanounce">
            <button className="close-heberg" onClick={this.toogleClosePhotos} >
              <span><FontAwesomeIcon icon={faTimes} /></span>
            </button>
            <div className="title-announce" >
              Nouvelle Annonce - Hebergement
            </div>
          </nav>

          <div className="path-heberg">
            <div className="item-path-hebrg" style={{borderRadius:"30px",marginLeft:"-15px"}}>

              <div className="number-path">
                <span className="number-path-value">1</span>
              </div>

              <span className="name-path" >
                Détails
                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

              </span>

            </div>

            <div className="item-path-hebrg" style={{ backgroundColor: "#182952",borderRadius:"30px",marginLeft:"-15px" }}>

              <div className="number-path" style={{ backgroundColor: "white" }} >
                <span className="number-path-value" style={{ color: "#182952" }} >2</span>
              </div>

              <span className="name-path" style={{ color: "white" }}>
                Photos
                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

              </span>

            </div>

            <div className="item-path-hebrg">

              <div className="number-path">
                <span className="number-path-value">3</span>
              </div>

              <span className="name-path last-path">
                Agenda

              </span>

            </div>


          </div>

          <ModalBody style={{ marginTop: "100px" }}>
            <Container>
              <Row>
                <Col md="7" className="pr-2">
                  <div className="img-ann" style={{ width: "100%", height: "400px" }}>
                    {
                      imag0 &&
                      <>
                        <img src={this.state.imgUrl[0]} className="exs-main-img" alt="" />
                      </>
                    }

                    {
                      !imag0 &&
                      <div className="img-holder">
                        <img src="/imgs/dashboard/add.svg" className="add-main-img" alt="" />
                      </div>
                    }

                  </div>
                </Col>

                <Col md="5">

                  <Row className="row-half-height mb-2">
                    <Col sm="6" className="px-2">
                      {
                        imag1 &&
                        <>
                          <img src={this.state.imgUrl[1]} className="exs-img" alt="" />
                        </>
                      }

                      {
                        !imag1 &&
                        <div className="img-holder">
                          <img src="/imgs/dashboard/add.svg" className="add-img" alt="" />
                        </div>
                      }
                    </Col>

                    <Col sm="6" className="pdt px-2">
                      {
                        imag2 &&
                        <>
                          <img src={this.state.imgUrl[2]} className="exs-img" alt="" />
                        </>
                      }

                      {
                        !imag2 &&
                        <div className="img-holder">
                          <img src="/imgs/dashboard/add.svg" className="add-img" alt="" />
                        </div>
                      }
                    </Col>
                  </Row>

                  <Row className="row-half-height">
                    <Col sm="6" className="pdt px-2">
                      {
                        imag3 &&
                        <>
                          <img src={this.state.imgUrl[3]} className="exs-img" alt="" />
                        </>
                      }

                      {
                        !imag3 &&
                        <div className="img-holder">
                          <img src="/imgs/dashboard/add.svg" className="add-img" alt="" />
                        </div>
                      }
                    </Col>
                    <Col sm="6" className="pdt px-2">
                      {
                        imag4 &&
                        <>
                          <img src={this.state.imgUrl[4]} className="exs-img" alt="" />
                        </>
                      }

                      {
                        !imag4 &&
                        <div className="img-holder">
                          <img src="/imgs/dashboard/add.svg" className="add-img" alt="" />
                        </div>
                      }
                    </Col>
                  </Row>

                </Col>

              </Row>

              <center className="files-upload-btn">

                <form enctype="multipart/form-data">

                  <label for='upload-photo' className="btn button-add-moule add-imgs-button" > <span id="ajouter-text"><FontAwesomeIcon icon={faPlus} />Ajouter des photos</span></label>
                  {this.state.imgUrl.length >= 5 && <p style={{ color: "red" }}>Max 5 photos</p>}
                  <input type="file" name="myImage[]" id="upload-photo" disabled={this.state.imgUrl.length >= 5}
                    onChange={this.onChangeUpload.bind(this)}
                  />
                  {/* <input type="text" name="imageUrl" placeholder="image url" /> */}

                </form>
              </center>

              <br /> <br />
              <h6 style={{ color: "rgb(119, 113, 113)" }}>Ps : Vous pouvez télecharger jusqu'a 4 photos a la fois ,sous formats JPEG,PNG,BMP ou TIFF</h6>
              <Row>
                <div className="buttons-add-announce-photos">
                  <Button className=" btn button-add-moule retour-button" onClick={() => { this.toogleClosePhotos(); this.toogleCloseAgendaWindows(); }}><FontAwesomeIcon id="arrow-retour" icon={faAngleLeft} />Retour</Button>
                  <Button className=" btn button-add-moule suivant-button"
                    onClick={() => {
                      this.toogleClosePhotos()
                      this.props.dispatch(addAgendaHeberg())
                    }
                    }
                  >Suivant<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} /></Button>
                </div>
              </Row>
            </Container>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.props.addAgendaHeberg} toggle={this.toogleCloseAgendaWindows} className="modal-width-details-announce">
          <nav className="nav-windows-addanounce">
            <button className="close-heberg" onClick={this.toogleCloseAgendaWindows} >
              <span><FontAwesomeIcon icon={faTimes} /></span>
            </button>
            <div className="title-announce" >
              Nouvelle Annonce - Hebergement
            </div>
          </nav>

          <div className="path-heberg" >
            <div className="item-path-hebrg" style={{ marginLeft:"-15px"}}>

              <div className="number-path" >
                <span className="number-path-value" >1</span>
              </div>

              <span className="name-path" >
                Détails
                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

              </span>

            </div>

            <div className="item-path-hebrg" style={{marginRight:"15px"}}>

              <div className="number-path" >
                <span className="number-path-value" >2</span>
              </div>

              <span className="name-path" >
                Photos
                <FontAwesomeIcon className="icon-path" icon={faAngleRight} />

              </span>

            </div>

            <div className="item-path-hebrg" style={{ backgroundColor: "#182952",borderRadius:"30px" }}>

              <div className="number-path" style={{ backgroundColor: "white" }}>
                <span className="number-path-value" style={{ color: "#182952" }} >3</span>
              </div>

              <span className="name-path " style={{ color: "white" }}>
                Agenda

              </span>

            </div>



          </div>



          <ModalBody>
            <div className="line-after-path"></div>
            <Container>
              <div className="custom-container">
                <Form onChange={this.onInputChange.bind(this)} onSubmit={this.postAnnounceHeberg.bind(this)}>
                  {/* <div className="line-after-path second-Row"></div> */}
                  <div className="text-center">
                    <h3 className="color-gh font-weight-bold">veullez entres les dates de disponibilité de votre Hébergement</h3>
                    <p className="text-muted">vous pouvez gereer votre agenda dans les modules (modifier une annonce) apres la publications de votre annoce  </p>
                  </div>
                  {
                    dates.map((data, i) => {
                      return (
                        <Row className="justify-content-center" key={i}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDateRangePicker
                              startText="date de depart "
                              endText="date de retour"
                              value={data}
                              disablePast
                              onChange={(newValue) => {
                                let values = this.state.dates;
                                values[i] = newValue;
                                this.setState({
                                  dates: [...values]
                                })
                              }}
                              renderInput={(startProps, endProps) => (
                                <div className="m-4">
                                  <Row className="h5 font-weight-bold border-bottom border-secondary" >
                                    <div className=" color-gh">
                                      <span className="m-2 ">
                                        Début
                                      </span>
                                      <img className="mx-2" style={{ width: "25px" }} src="/imgs/ghurfatiFilter/calendar_icn.svg" alt="" />
                                      <input className="border-0" style={{ height: "35px" }} ref={startProps.inputRef} {...startProps.inputProps} />
                                    </div>
                                    <div className=" color-gh ">
                                      <span className="m-2">
                                        Fin
                                      </span>
                                      <img className="mx-2" style={{ width: "25px" }} src="/imgs/ghurfatiFilter/calendar_icn.svg" alt="" />
                                      <input className="border-0" style={{ height: "35px" }} ref={endProps.inputRef} {...endProps.inputProps} />
                                    </div>
                                    <div>

                                    </div>
                                  </Row>
                                </div>
                              )}
                            />
                          </LocalizationProvider>
                          {i > 0 ?
                            <button className="btn p-0" onClick={evt => this.handleRemoveFields(evt, i)}>
                              <img src="/imgs/dash/close-thick.svg" className=" w-50" alt="" />
                            </button>
                            : <div className="p-4">
                            </div>
                          }
                        </Row>

                      )
                    })

                  }

                  <div className="text-center">
                    <button className="btn" onClick={evt =>{ this.handleAddFields(evt); }}>
                      <img src="/imgs/dash/add_green.svg" alt="" />
                    </button>
                  </div>



                  <Row>
                    <div className="buttons-details-announces">
                      <Button className=" btn button-add-moule retour-button" onClick={evt => {
                        this.toogleCloseAgendaWindows();
                        this.toogleClosePhotos();
                        // this.props.dispatch(addPhotoHeberg())
                      }}>
                        <FontAwesomeIcon id="arrow-retour" icon={faAngleLeft}
                        />Retour</Button>
                      <Button className=" btn button-add-moule suivant-button"
                        type="submit"
                        // disabled={!this.state.announceHbergInfo.title || !this.state.announceHbergInfo.description}
                        onClick={() => {
                          this.FormatAgenda()
                        }}
                      >Suivant<FontAwesomeIcon id="arrow-suivant" icon={faAngleRight} />
                      </Button>
                      {/* onClick={this.postAnnounceHeberg.bind(this)} */}
                    </div>
                  </Row>
                </Form>

              </div>
            </Container>
          </ModalBody>
        </Modal>









      </div>
    );
  }
}




function mapStateToProps(state) {
  return {

    addAnn: state.modal.addAnn,
    addHeberg: state.modal.addHeberg,
    addPhotoHeberg: state.modal.addPhoto,
    addAgendaHeberg: state.modal.addAgendaHeberg,


  }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(AddAnnounceHbergement);